import { Bindings } from "booking_app/types";
import { HotelResultFilterMobileController } from "./hotel-result-filter-mobile.controller";

export class HotelResultFilterMobileComponent {
  controller: any = HotelResultFilterMobileController;
  templateUrl: string = "/html/components/hotel_result_filter_mobile";
}

angular.module("BookingApp").component("hotelResultFilterMobile", new HotelResultFilterMobileComponent());
